(function ($) {
    'use strict';

    $(document).ready(function () {

        $('[data-cancer-navigation-search]').each(function () {

            var $search = $(this);

            var $input =
                $search.find('[data-cancer-navigation-search-input]');

            var $items =
                $search.find('[data-cancer-navigation-search-item]');

            var $noResults =
                $search.find('[data-cancer-navigation-search-no-results]');

            var $noResultsTerm =
                $search.find('[data-cancer-navigation-search-term]');


            $input.on('input', function () {

                var searchTerm =
                    $.trim($(this).val()).toLowerCase();

                var visibleCount = 0;

                $items.each(function () {

                    var $item = $(this);

                    var itemText =
                        ($item.attr('data-search-text') || '')
                            .toLowerCase();

                    var matches =
                        !searchTerm ||
                        itemText.indexOf(searchTerm) !== -1;

                    $item.toggle(matches);

                    if (matches) {
                        visibleCount++;
                    }

                });


                if (visibleCount === 0) {

                    $noResultsTerm.text(
                        $(this).val()
                    );

                    $noResults.show();

                }
                else {

                    $noResults.hide();

                }

            });

        });

    });

})(jQuery);